import { TrimPanZoomManager } from './pan-zoom/trim.pan-zoom.manager';
import { TrimEditableImageManager } from './editable-image/trim.editable-image.manager';
import { TrimUiManager } from './ui/trim.ui.manager';
import { TrimKeyboardManager } from './keyboard/trim.keyboard.manager';
import { TrimPrintManager } from '../print/trim.print';
import { TrimImageProcessorManager } from './image-processor/trim.image-processor.manager';
import { TrimFontManager } from './font/trim.font.manager';
import { TrimWebFontManager } from './web-font/trim.web-font.manager';
import { TrimRestoreEditableImageManager } from './restore-editable-image/trim.restore-editable-image.manager';
import { TrimDataManager } from './data/trim-data.manager';
import { TrimThumbManager } from './thumb/trim.thumb.manager';
import { TrimZipManager } from './zip/trim.zip.manager';
import { TrimValidationManager } from './validation/trim.validation.manager';
import { TrimAdditionalManager } from './additional/trim.additional.manager';
import { TrimTextImageManager } from './text-image/trim.text-image.manager';
import { TrimImageEditManager } from './image-edit/trim.image-edit.manager';
import { TrimColorDropperManager } from './color-dropper/trim.color-dropper.manager';
import { TrimCommandManager } from './command/trim.command.manager';
import { TrimRulerManager } from './ruler/trim.ruler.manager';
import { TrimPosManager } from './pos/trim.pos.manager';
import { TrimTrimmingManager } from './trimming/trim.trimming.manager';

export interface ITrimEditorManagerBase {
  initialize(): void;

  destroy(): void;

  di(...manager: ITrimEditorManagerBase[]): void;
}

export class TrimEditorManager implements ITrimEditorManagerBase {

  container: HTMLDivElement;

  manager: {
    trimPrint: TrimPrintManager,
    colorDropper: TrimColorDropperManager,
    command: TrimCommandManager,
    editableImage: TrimEditableImageManager,
    font: TrimFontManager,
    imageEdit: TrimImageEditManager,
    imageProcessor: TrimImageProcessorManager,
    keyboard: TrimKeyboardManager,
    layoutData: TrimDataManager,
    ruler: TrimRulerManager,
    panZoom: TrimPanZoomManager,
    preview: TrimThumbManager,
    restoreEditableImage: TrimRestoreEditableImageManager,
    ui: TrimUiManager,
    webFont: TrimWebFontManager,
    zip: TrimZipManager,
    valid: TrimValidationManager,
    additional: TrimAdditionalManager,
    text: TrimTextImageManager,
    pos: TrimPosManager,
    trim: TrimTrimmingManager,
  };

  constructor(container: HTMLDivElement) {
    // layout.edit-template.tsx
    this.container = container;
    this.manager = {
      trimPrint: new TrimPrintManager(),
      colorDropper: new TrimColorDropperManager(),
      command: new TrimCommandManager(),
      editableImage: TrimEditableImageManager.ins,
      font: TrimFontManager.ins,
      imageEdit: new TrimImageEditManager(container),
      imageProcessor: TrimImageProcessorManager.ins,
      keyboard: new TrimKeyboardManager(),
      layoutData: new TrimDataManager(),
      ruler: new TrimRulerManager(container),
      panZoom: new TrimPanZoomManager(),
      preview: new TrimThumbManager(),
      restoreEditableImage: TrimRestoreEditableImageManager.ins,
      ui: TrimUiManager.ins,
      webFont: new TrimWebFontManager(),
      zip: new TrimZipManager(),
      valid: new TrimValidationManager(),
      additional: new TrimAdditionalManager(),
      text: new TrimTextImageManager(),
      pos: new TrimPosManager(),
      trim: new TrimTrimmingManager(),
    };
    // - di -
    this.manager.trimPrint.di();
    this.manager.colorDropper.di(this.manager.imageEdit, this.manager.ui, this.manager.trimPrint);
    this.manager.command.di();
    this.manager.editableImage.di();
    this.manager.font.di(this.manager.ui);
    this.manager.imageEdit.di(
      this.manager.command,
      this.manager.trimPrint,
      this.manager.editableImage,
      this.manager.panZoom,
      this.manager.layoutData,
      this.manager.preview,
      this.manager.ruler,
      this.manager.pos,
      this.manager.trim,
      this.manager.additional
    );
    this.manager.imageProcessor.di();
    this.manager.keyboard.di(this.manager.ui);
    this.manager.layoutData.di(this.manager.ui, this.manager.trimPrint, this.manager.editableImage, this.manager.imageEdit, this.manager.preview, this.manager.text);
    this.manager.panZoom.di(this.manager.ui, this.manager.trimPrint, this.manager.imageEdit);
    this.manager.preview.di();
    this.manager.restoreEditableImage.di();
    this.manager.ruler.di(this.manager.imageEdit, this.manager.ui, this.manager.panZoom);
    this.manager.ui.di();
    this.manager.webFont.di(this.manager.ui);
    this.manager.zip.di(this.manager.ui);
    this.manager.valid.di(this.manager.ui, this.manager.layoutData, this.manager.editableImage, this.manager.trimPrint);
    this.manager.additional.di();
    this.manager.pos.di(this.manager.imageEdit, this.manager.ui, this.manager.panZoom)
    this.manager.trim.di(this.manager.ui, this.manager.pos, this.manager.trimPrint, this.manager.imageEdit)
  }

  di() {
  }

  initialize() {
    Object.values<ITrimEditorManagerBase>(this.manager)
      .forEach((manager) => {
        manager.initialize();
      });
  }

  destroy() {
    Object.values<ITrimEditorManagerBase>(this.manager)
      .forEach((manager) => {
        if (manager === this.manager.editableImage) {
          (manager as TrimEditableImageManager).leaveFromLayoutPage();
        } else {
          manager.destroy();
        }
      });
  }

}
